import { type IRedirectNotification } from 'dto/NotificationDTO'
import { useHistory } from 'react-router-dom'
import { redirectOrderNotification } from './order'
import {
  redirectFinancingNotification,
  redirectFinancingSimulationNotification,
} from './financing'
import { NOTIFICATION_TYPES_ENUM } from 'enums/notification/NotificationTypes'

export const useRedirectNotification = () => {
  const history = useHistory()

  const notificationPath = {
    [NOTIFICATION_TYPES_ENUM.ORDER]: redirectOrderNotification,
    [NOTIFICATION_TYPES_ENUM.FINANCING_PENDING]:
      redirectFinancingSimulationNotification,
    [NOTIFICATION_TYPES_ENUM.FINANCING_PRE_APPROVED]:
      redirectFinancingNotification,
    [NOTIFICATION_TYPES_ENUM.FINANCING_APPROVED]: redirectFinancingNotification,
    [NOTIFICATION_TYPES_ENUM.FINANCING_CUSTOMER_REQUEST]:
      redirectFinancingNotification,
  }

  const redirectNotification = (notification: IRedirectNotification) => {
    const URL = notificationPath[notification.type](notification)
    return history.push(URL)
  }

  return { redirectNotification }
}
